import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { makeStyles, createStyles } from '@mui/styles';
//| import { Theme } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import styles from '../../../styles/_variables.module.scss';
import { Theme } from '@mui/material';

const useDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      paddingBottom: 0,
    },
    icon: {
      cursor: 'pointer',
      userSelect: 'none',
      color: theme.palette.grey[500],
    },
    message: {
      fontWeight: Number(styles.semiBoldTextWeight),
      fontSize: '1.0625rem',
    },
    content: {
      padding: '2rem 3rem',
      paddingTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    actions: {
      marginTop: '1.4rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    okButton: {
      marginLeft: '1rem',
    },
  }),
);

interface BusinessConfirmationDialogProps {
  open: boolean;
  setOpen(value: boolean): void;
  message: string;
  action(): void;
}

function BusinessConfirmationDialog({ open, setOpen, message, action }: BusinessConfirmationDialogProps) {
  const classes = useDialogStyles();

  const handleOk = () => {
    console.log('BusinessConfirmationDialog: confirm clicked');
    try {
      action();
    } catch (err) {
      console.error('BusinessConfirmationDialog: action error', err);
    }
    setOpen(false);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog className="dialog" open={open} onClose={closeDialog}>
      <DialogTitle className={classes.title}>
        <CloseIcon fontSize="medium" className={classes.icon} onClick={closeDialog} />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.message}>{message}</Typography>
        <div className={classes.actions}>
          <Button type="button" onClick={closeDialog} variant="outlined" color="secondary">
            Revisar datos
          </Button>
          <Button
            type="button"
            data-testid="business-confirm-btn"
            color="primary"
            className={classes.okButton}
            variant="contained"
            onClick={handleOk}
          >
            Si, crear cuenta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BusinessConfirmationDialog;
